var map = {
	"./australia.png": "f625",
	"./cuba.png": "a290",
	"./dominicana.png": "e639f",
	"./japan.png": "93b1",
	"./korea.png": "dee2",
	"./mexico.png": "736d",
	"./nederland.png": "7232",
	"./panama.png": "1486",
	"./puerto-rico.png": "f23f",
	"./taiwan.png": "534d",
	"./usa.png": "7cc8",
	"./venezuela.png": "2f8e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dd28";